// Module
var code = `<form-section form-title="'Related Non-Customers'">
    <table class="table table--wide">
        <thead>
        <th class="numbers">No.</th>
        <th>First name</th>
        <th>Middle name</th>
        <th>Last name</th>
        <th>Extension</th>
        <th>Relationship</th>
        <th>Beneficiary</th>
        <th>Dependent</th>
        <th>Birth Date</th>
        <th>Birth place</th>
        <th>Mobile number</th>
        <th>&nbsp;</th>
        </thead>
        <tbody class="tbody">
        <tr ng-repeat="rel in \$ctrl.relatives">
            <td>{{\$index+1}}.</td>
            <td class="label">
                <input type="text"
                       ng-model="rel.firstName"
                       ng-disabled="!\$ctrl.editMode"
                       required>
            </td>
            <td class="label">
                <input type="text"
                       ng-model="rel.middleName"
                       ng-disabled="!\$ctrl.editMode">
            </td>
            <td class="label">
                <input type="text"
                       ng-model="rel.lastName"
                       ng-disabled="!\$ctrl.editMode"
                       required>
            </td>
            <td class="label">
                <select ng-model="rel.extensionId"
                        ng-disabled="!\$ctrl.editMode"
                        ng-options="o.id as o.description for o in \$ctrl.dict.CUSTOMER_NAME_EXTENSION">
                  <option></option>
                </select>
            </td>
            <td class="label">
                <select
                        ng-model="rel.typeId"
                        ng-disabled="!\$ctrl.editMode"
                        ng-options="o.id as o.description for o in \$ctrl.typeOptions"
                        ng-required="true"></select>
            </td>
            <td class="label">
                <select
                        ng-model="rel.beneficiary"
                        ng-disabled="!\$ctrl.editMode"
                        boolean-options
                        ng-required="true">
                </select>
            </td>
            <td class="label">
                <select
                        ng-model="rel.dependent"
                        ng-disabled="!\$ctrl.editMode"
                        boolean-options
                        ng-required="true">
                </select>
            </td>
            <td class="label">
                <date ng-show="\$ctrl.editMode"
                      ng-model="rel.birthDate"
                      init-with-null="true"
                      ng-disabled="!\$ctrl.editMode"
                      validate-date="lt:real-date"
                      required></date>
                <span ng-show="!\$ctrl.editMode">{{rel.birthDate | prettyDate}}</span>
            </td>
            <td class="label">
                <input type="text"
                       ng-model="rel.birthPlace"
                       ng-disabled="!\$ctrl.editMode"
                       maxlength="64">
            </td>
            <td class="label">
                <telephone ng-model="rel.mobileNumber"
                           ng-disabled="!\$ctrl.editMode"></telephone>
            </td>
            <td class="buttons">
                <button type="button"
                        class="btn btn-danger"
                        ng-if="\$ctrl.editMode"
                        ng-click="\$ctrl.removeRelative(rel)">Remove
                </button>
            </td>
        </tr>
        <tr ng-if="\$ctrl.editMode">
            <td>{{\$ctrl.relatives.length + 1}}.</td>
            <td colspan="10"></td>
            <td class="buttons">
                <button type="button"
                        class="btn btn-success"
                        ng-if="\$ctrl.editMode"
                        ng-click="\$ctrl.addRelative()">Add
                </button>
            </td>
        </tr>
        </tbody>
    </table>
</form-section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/related-non-customers/related-non-customers.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;